"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _compose = _interopRequireDefault(require("transmute/compose"));

var _generalStore = require("general-store");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _propertiesCardDependencies = require("crm_ui/profile/sidebar/properties/propertiesCardDependencies");

var _withPropertySave = require("customer-data-sidebar/cards/AboutCard/withPropertySave");

var _Content = _interopRequireDefault(require("customer-data-sidebar/cards/AboutCard/Content"));

var _default = (0, _compose.default)((0, _generalStore.connect)(_propertiesCardDependencies.dependencies, _dispatcher.default), _withPropertySave.withPropertySave)(_Content.default);

exports.default = _default;
module.exports = exports.default;